<div class="control-container">
    <se-line-graph
        [lines]="data"
        [propX]="control.x.prop"
        [propY]="control.y.prop"
        completeRange="true"
        debug="true"
        scaleY="time"
    >
    </se-line-graph>
</div>
